import { useCallback, useEffect, useMemo, useState } from "react"
import { AppUIContext } from "./AppUIContext"
import { matchPath, useLocation } from "react-router-dom"
import config from "config"
import { useNavigationHistory } from "./hooks"
import { useAppNavigation } from "./hooks/useAppNavigation/useAppNavigation"

//TODO:: find a better way for handling showing bottom navigation on each venue case
//[PR#661](https://gitlab.com/forviz/venue/venue-webapp/-/merge_requests/661)
const NO_NAVIGATION_BAR_PAGES = [
  "all::/maps/dir/:origin/:destination/navigate/steps/:step",
  "jungceylon::/",
  "tourist-friendly::/",
  "all::/maps/dir/:origin/:destination",
]

export const AppUIProvider = ({ children }) => {
  const location = useLocation()
  const [openSearchState, setOpenSearchState] = useState(false)
  const [sidebarState, setSidebarState] = useState(false)
  const [showBottomNavigation, setShowBottomNavigation] = useState(true)
  const venueExtension = config("venueExtension")
  const [mapReady, setmapReady] = useState(false)
  const { goBack } = useNavigationHistory()
  const {
    navigations,
    mobileNavigations,
    mobileMainNavigations,
    kioskNavigation,
    kioskMainNavigations,
  } = useAppNavigation()

  const openSearch = useCallback(() => {
    setOpenSearchState(true)
  }, [])

  const closeSearch = useCallback(() => {
    setOpenSearchState(false)
  }, [])

  const toggleSearch = useCallback(() => {
    setOpenSearchState((prev) => !prev)
  }, [])

  const isKioskMode = useMemo(
    () => ["kiosk-v", "kiosk-h"].includes(config("device")),
    []
  )

  useEffect(() => {
    setShowBottomNavigation(
      !NO_NAVIGATION_BAR_PAGES.find((path) => {
        const [extensionName, pathToCheck] = path.split("::")
        const isOnlyExtension = extensionName !== "all"
        const isMatched = !!matchPath(pathToCheck, location.pathname)
        return isOnlyExtension
          ? venueExtension.includes(extensionName) && isMatched
          : isMatched
      })
    )
  }, [location.pathname, venueExtension])

  // Disable right click on the screen when application is in kiosk mode
  useEffect(() => {
    if (config("env") === "production" && isKioskMode) {
      window.addEventListener("contextmenu", (event) => event.preventDefault())
    }
  }, [isKioskMode])

  const value = {
    openSearchState,
    sidebarState,
    showBottomNavigation,
    mapReady,
    isKioskMode,
    // Navigation
    navigations,
    mobileNavigations,
    mobileMainNavigations,
    kioskNavigation,
    kioskMainNavigations,
    // functions
    openSearch,
    closeSearch,
    toggleSearch,
    setmapReady,
    setOpenSearchState,
    setSidebarState,
    goBack,
  }

  return <AppUIContext.Provider value={value}>{children}</AppUIContext.Provider>
}
